import { render, staticRenderFns } from "./OrderEspagoForm.vue?vue&type=template&id=440b6334"
import script from "./OrderEspagoForm.vue?vue&type=script&lang=js"
export * from "./OrderEspagoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports